import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import {
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_PLAYER_BEHAVIOR,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_GAME_TYPES,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT_RESULT,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_MESSAGES_MENTOR,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS,
	ROUTE_ACCOUNT_RISK_PROFILE
} from '~/components/router/constants.js';
import {
	GameTypes,
	GamingHabits,
	MessagesMentorWrapper,
	PlayerBehavior,
	RiskProfile,
	SelfAssessmentResult,
	SelfAssessment
} from '../async.js';
import { getRelativePaths } from '~/utils/pathname';
import { useMemo } from 'react';

const CHILD_ROUTES = [
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_PLAYER_BEHAVIOR,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_GAME_TYPES,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT_RESULT,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_MESSAGES_MENTOR,
	ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS
];

const RiskProfileGateway = () => {
	const { enableGamingHabitsMentor } = useSelector(state => state.brand);

	const paths = useMemo(() => getRelativePaths(CHILD_ROUTES, ROUTE_ACCOUNT_RISK_PROFILE), []);

	return (
		<TracedRoutes>
			<Route index element={<RiskProfile />} />

			{enableGamingHabitsMentor && (
				<>
					<Route path={paths[ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS]} element={<GamingHabits />} />
					<Route
						path={paths[ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_PLAYER_BEHAVIOR]}
						element={<PlayerBehavior />}
					/>
					<Route path={paths[ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_GAME_TYPES]} element={<GameTypes />} />
					<Route
						path={paths[ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT]}
						element={<SelfAssessment />}
					/>
					<Route
						path={paths[ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT_RESULT]}
						element={<SelfAssessmentResult />}
					/>
					<Route
						path={paths[ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_MESSAGES_MENTOR]}
						element={<MessagesMentorWrapper />}
					/>
				</>
			)}
		</TracedRoutes>
	);
};

export default RiskProfileGateway;
